module.exports = __webpack_public_path__ + "img/logo_EN.9c649964.png";